import Vue from "vue";
import VueRouter, { NavigationGuard, RouteConfig } from "vue-router";
import DrinkFrequency from "@dcc/views/DrinkFrequency.vue";
import NonDrinkResults from "@dcc/views/NonDrinkResults.vue";
import DaysOfWeek from "@dcc/views/DaysOfWeek.vue";
import AverageDay from "@dcc/views/AverageDay.vue";
import MonthlyDays from "@dcc/views/MonthlyDays.vue";
import SingleOccasion from "@dcc/views/SingleOccasion.vue";
import DrinkerResultsMonthly from "@dcc/views/DrinkerResultsMonthly.vue";
import DrinkerResultsWeekly from "@dcc/views/DrinkerResultsWeekly.vue";
import ActionPlan from "@dcc/views/ActionPlan.vue";
import DrinksPerWeekDay from "@dcc/views/DrinksPerWeekDay.vue";
import ActionPlanResults from "@dcc/views/ActionPlanResults.vue";
import Profile from "@dcc/views/Profile.vue";
import Welcome from "@dcc/views/Welcome.vue";

import store from "@dcc/store";
import { getActions } from "@dcc/store/actions";
import { RouteNames } from "./definitions";
import { VueConstructor } from "vue/types/umd";
import { QueryParamToAppGender } from "../store/utils";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/welcome",
    name: RouteNames.welcome,
    component: Welcome as VueConstructor<Vue>
  },
  {
    path: "/profile",
    name: RouteNames.profile,
    component: Profile as VueConstructor<Vue>
  },
  {
    path: "/drinkfrequency",
    name: RouteNames.drinkFrequency,
    component: DrinkFrequency as VueConstructor<Vue>
  },
  {
    path: "/nondrinkresults",
    name: RouteNames.nonDrinkResults,
    component: NonDrinkResults as VueConstructor<Vue>
  },
  {
    path: "/daysofweek",
    name: RouteNames.daysOfWeek,
    component: DaysOfWeek as VueConstructor<Vue>
  },
  {
    path: "/averageday",
    name: RouteNames.averageDay,
    component: AverageDay as VueConstructor<Vue>
  },
  {
    path: "/monthlydays",
    name: RouteNames.monthlydays,
    component: MonthlyDays as VueConstructor<Vue>
  },
  {
    path: "/drinksperweekday",
    name: RouteNames.drinksPerWeekDay,
    component: DrinksPerWeekDay as VueConstructor<Vue>
  },
  {
    path: "/singleoccasion",
    name: RouteNames.singleOccasion,
    component: SingleOccasion as VueConstructor<Vue>
  },
  {
    path: "/drinkerresultsmonthly",
    name: RouteNames.drinkerResultsMonthly,
    component: DrinkerResultsMonthly as VueConstructor<Vue>
  },
  {
    path: "/drinkerresultsweeekly",
    name: RouteNames.drinkerResultsWeekly,
    component: DrinkerResultsWeekly as VueConstructor<Vue>
  },
  {
    path: "/actionplan/:tab",
    name: "actionplan",
    component: ActionPlan as VueConstructor<Vue>,
    props: true
  },
  {
    path: "/actionplanresults",
    name: "actionplanresults",
    component: ActionPlanResults as VueConstructor<Vue>,

    props: (route) => {
      const {
        percentage,
        dropped_days,
        calories_week,
        units_week,
        gender,
        num_drinking_days,
        tips
      } = route.query;

      return {
        percentage: percentage ? Number(percentage) : undefined,
        dropped_days: dropped_days ? Number(dropped_days) : undefined,
        calories_week: calories_week ? Number(calories_week) : undefined,
        units_week: units_week ? Number(units_week) : undefined,
        tips: tips ? (tips as string).split(",") : undefined,
        gender: QueryParamToAppGender(gender),
        num_drinking_days: num_drinking_days
          ? Number(num_drinking_days)
          : undefined
      };
    }
  },
  {
    path: "*",
    name: RouteNames.welcome,
    component: Welcome as VueConstructor<Vue>
  }
];

const router = new VueRouter({
  mode: "abstract",
  base: process.env.BASE_URL,
  routes
});

const guard: NavigationGuard<Vue> = (to, from, next) => {
  const { updateRoute } = getActions(store);
  if (to.name) updateRoute(to.name);
  window.scrollTo(0, 0);
  next();
};

router.beforeEach(guard);

export default router;
